import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import cn from 'classname';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { baseUrl } from '../../../../config/route-entry-point';
import { getCurrencyIcon } from '../../../../../shared/js/get-currency-icon';

import InputField from '../../../shared/form-elements/input';
import SelectField from '../../../shared/form-elements/select';
import sortKeys from '../../../../../shared/js/sort';

import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';

lessRequire('modules/profile/components/forms/payment.less');

const Payments = (props) => {
	const {
		handleSubmit,
		createPayoutSetting,
		data,
		showAddPaymentForm,
		updatePaymentsFields,
		payoutCredentialFields,
		intl
	} = props;

	const { connectedSystems, systemsOptions, showForm, formFields, selectedNewSystem } = data;

	const fields = formFields ? sortKeys(formFields) : [];

	return (
		<div className="profile__payment half-width">
			{map(connectedSystems, (system, i) => {
				const credentials = system.fields ? sortKeys(system.fields) : [];

				return (
					<div key={i} className="system clearfix">
						<div className="payment_icon">
							<img src={system.image || '//placehold.it/30x30'} alt=""/>
						</div>
						<div className="font-proxima-nova-semibold title">
							{system.title} ({getCurrencyIcon(system.currency)})
						</div>

						<div className="fields">
							{!!credentials.length && credentials.map((key, ind) => {
								return (<div key={`sys${system.title}${key}`} className="profile-wrap__form-field clearfix">
									<div className="profile-wrap__position-left clearfix">
										<span className="pseudoInput">
											<span className="pseudoLabel">{find(payoutCredentialFields, {value: key}).label}</span>
											{formatPayoutCredentialsField(system.credentials[key], key)}
										</span>
									</div>

									<div className="profile-wrap__position-left">
										{ind == 0 ? (
											<i className={cn(
												'profile-wrap__change-info',
												'font-times-new-roman-italic',
												!!Number(system.payout_percent) && 'payout-percent'
											)}>
												<div>
													{intl('Минимальная сумма выплаты')}{' '}
													{`${system.allow_floats
														? parseFloat(system.min_amount)
														: parseFloat(system.min_amount).toFixed(0)} ${getCurrencyIcon(system.currency)}. `}
												</div>
												{!!Number(system.payout_percent) &&
												<div>
													{ Number(system.payout_percent) > 0 ?
														intl('Бонус') + ' ' + Number(system.payout_percent).toString() :
														intl('Комиссия') + ' ' + Math.abs(Number(system.payout_percent)).toString()}{'%.'}
												</div>}
												{intl('Изменение данных возможно только после обращения к')}&nbsp;
												<a href={baseUrl('dashboard/')}>
													{intl('личному менеджеру')}
												</a>.
											</i>
										) : null}
									</div>
								</div>);
							})}
						</div>

					</div>
				);
			})}

			{showForm ? (
				<form action="#"
					className="form"
					onSubmit={handleSubmit(createPayoutSetting)}
				>
					<div>
						<Field name="system"
							component={SelectField}
							placeholder={intl('Выберите систему')}
							options={systemsOptions}
							onChange={updatePaymentsFields}
						/>
						{
							selectedNewSystem && (
								<span className="ps-percent font-times-new-roman-italic">
									{intl('Комиссия')} {getPayoutSystemPersent(selectedNewSystem.payout_percent)}%
								</span>
							)
						}
						<a
							href="#"
							className="close-paymant-form font-proxima-nova-regular"
							onClick={e => {
								e.preventDefault();
								props.hidePaymentForm();
							}}
						>{intl('Закрыть форму')}</a>
					</div>
					{
						selectedNewSystem && selectedNewSystem.module == 'directAdvert' &&
					<div className="direct-advert-info font-times-new-roman-italic">
						{intl(
							'Для получения возможности выплат, обратитесь в службу поддержки ДА ' +
							'через чат или почту для подключения вашего аккаута к агентскому кабинету Everad'
						)}
					</div>
					}
					{
						selectedNewSystem && selectedNewSystem.module == 'marketgid' &&
					<div className="direct-advert-info font-times-new-roman-italic">
						{intl(
							'Для получения возможности выплат вы должны быть зарегистрированы в MGID по реферальной ссылке Everad'
						)}
					</div>
					}
					<div className="fields">
						{!!fields.length && fields.map(key => {
							return (<div key={`field_${key}`} className="profile-wrap__form-field clearfix">
								<div className="profile-wrap__position-left clearfix">
									<Field name={key}
										placeholder={find(payoutCredentialFields, {value: key}).label}
										component={InputField}
									/>
								</div>

								<div className="profile-wrap__position-left">
									<i className="profile-wrap__change-info font-times-new-roman-italic">
										{intl('Данные конфиденциальны и не разглашаются сторонним лицам')}
									</i>
								</div>
							</div>);
						})}
					</div>
					{!isEmpty(formFields) && (
						<button	className="button transparent profile-change-btn font-proxima-nova-semibold"
							type="submit"
						>
							{intl('Добавить систему')}
						</button>
					)}
				</form>
			) : (
				<div>
					{!isEmpty(systemsOptions) && (
						<button	className="button transparent profile-change-btn font-proxima-nova-semibold"
							onClick={showAddPaymentForm}
						>
							{intl('Добавить систему')}
						</button>
					)}
				</div>
			)}
		</div>
	);
};

function formatPayoutCredentialsField (value, type) {
	switch (type) {
		case 'card':
			return value.toString().replace(/\d{4} ?(?=\d{4})/g, '****');

		default:
			return value;
	}
}

const getPayoutSystemPersent = persentString => {
	const persent = parseFloat(persentString);
	if (!persent)
		return ` 0`;
	return persent > 0 ? ` +${persent}`: ` ${persent}`;
};

Payments.propTypes = {
	handleSubmit: PropTypes.func,
	createPayoutSetting: PropTypes.func,
	data: PropTypes.object,
	showForm: PropTypes.bool,
	showAddPaymentForm: PropTypes.func,
	updatePaymentsFields: PropTypes.func,
	formFields: PropTypes.array,
	payoutCredentialFields: PropTypes.array,
	hidePaymentForm: PropTypes.func,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'profilePaymentForm'
})(Payments);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/components/forms/payment.js